import React from "react";
import LegalLayout, { Section } from "./LegalLayout";

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <LegalLayout title="Privacy Policy" lastUpdated="February 2026">
        <p>
          JFeva Solutions, LLC (&ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) respects your privacy.
          This Privacy Policy explains what information we collect from visitors and customers, how we use it,
          and the choices you have. By using this site or requesting services, you agree to the terms below.
        </p>

        <Section title="Information We Collect" testid="privacy-collect">
          <p>We collect only information that is necessary to serve you:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li><span className="text-[color:var(--brand-ink)] font-medium">Contact details</span> — name, phone, email, and service address you provide on quote, booking, and contact forms.</li>
            <li><span className="text-[color:var(--brand-ink)] font-medium">Project information</span> — descriptions, dimensions, and photos you upload to help us estimate your project.</li>
            <li><span className="text-[color:var(--brand-ink)] font-medium">Payment records</span> — invoice, payment, and estimate history (we do not store full credit card numbers on this site).</li>
            <li><span className="text-[color:var(--brand-ink)] font-medium">Basic technical data</span> — standard web logs (IP, browser type, pages visited) used only for site performance and security.</li>
          </ul>
        </Section>

        <Section title="How We Use It" testid="privacy-use">
          <ul className="list-disc pl-6 space-y-1">
            <li>Respond to quote and booking requests.</li>
            <li>Schedule installations and send appointment confirmations.</li>
            <li>Prepare and send estimates, invoices, and warranty records.</li>
            <li>Improve our site and services, and comply with legal obligations.</li>
          </ul>
          <p>We do <span className="text-[color:var(--brand-ink)] font-medium">not</span> sell, rent, or trade your personal information.</p>
        </Section>

        <Section title="Who Can See Your Data" testid="privacy-share">
          <p>
            Access is limited to JFeva Solutions, LLC staff and trusted service providers who help us run the business
            (such as our email provider, cloud storage provider, and payment processor). Each is bound by appropriate
            confidentiality obligations and may only use your information to perform work on our behalf.
          </p>
        </Section>

        <Section title="Photos of Your Project" testid="privacy-photos">
          <p>
            With your permission, we may use before/after photos of completed projects on our website and marketing
            materials. If you would prefer we not display photos of your home or business, simply tell us at the time
            of your estimate — we will respect your choice.
          </p>
        </Section>

        <Section title="Data Retention" testid="privacy-retention">
          <p>
            We retain quote and booking submissions, estimates, and project files for as long as needed to service your
            warranty, resolve disputes, and comply with tax and legal obligations — typically up to 7 years. You may
            request deletion of your personal information at any time, subject to our legal retention duties.
          </p>
        </Section>

        <Section title="Your Rights" testid="privacy-rights">
          <ul className="list-disc pl-6 space-y-1">
            <li>Request access to the personal information we hold about you.</li>
            <li>Request correction of inaccurate information.</li>
            <li>Request deletion where legally permitted.</li>
            <li>Opt out of marketing communications at any time.</li>
          </ul>
          <p>
            To exercise any of these rights, email <a className="underline hover:text-[color:var(--brand-ink)]" href="mailto:info@jfeva.com">info@jfeva.com</a>.
          </p>
        </Section>

        <Section title="Cookies & Tracking" testid="privacy-cookies">
          <p>
            This site uses only essential cookies required to keep the site working (for example, keeping admin users
            signed in). We do not use advertising cookies or third-party trackers.
          </p>
        </Section>

        <Section title="Children" testid="privacy-children">
          <p>Our services are not directed to children under 13, and we do not knowingly collect their information.</p>
        </Section>

        <Section title="Updates to This Policy" testid="privacy-updates">
          <p>
            We may update this policy from time to time. The &ldquo;Last updated&rdquo; date above shows the latest revision.
            Significant changes will be posted on this page.
          </p>
        </Section>

        <Section title="Contact Us" testid="privacy-contact">
          <p>
            JFeva Solutions, LLC<br/>
            Email: <a className="underline hover:text-[color:var(--brand-ink)]" href="mailto:info@jfeva.com">info@jfeva.com</a><br/>
            Phone: <a className="underline hover:text-[color:var(--brand-ink)]" href="tel:8502520162">850-252-0162</a><br/>
            Service area: Florida &amp; surrounding areas
          </p>
        </Section>
      </LegalLayout>
    </div>
  );
}
